//Revolving
const REVOLVING = '/revolving/';
export const REVOLVING_PURCHASE = 'purchases';
export const REVOLVING_REFUNDS = 'refunds';
export const REVOLVING_QUERY = 'queries';

export const URL_REVOLVING_PURCHASE = REVOLVING + REVOLVING_PURCHASE;
export const URL_REVOLVING_REFUND = REVOLVING + REVOLVING_REFUNDS;
export const URL_REVOLVING_QUERY = REVOLVING + REVOLVING_QUERY;
//Control Panel
const CONTROL_PANEL = '/control-panel/';
export const CONTROL_PANEL_INVEST_DETAIL_OPERATION = 'invest-detail';
export const CONTROL_PANEL_INVEST_PRODUCT = 'invest-product';
export const CONTROL_PANEL_PENALTY_DETAIL_OPERATION = 'penalty-detail';
export const CONTROL_PANEL_OPERATION_DETAIL = 'operation-detail';
export const CONTROL_PANEL_AGENT_STATISTICS = 'agent-statistics';
export const CONTROL_PANEL_ACTION_AGENT = 'action-agent';
export const CONTROL_PANEL_OPERATION_VALIDATION = 'operation-validation';
export const CONTROL_PANEL_GENERAL_INVESTMENT = 'general-of-investment';

export const URL_CONTROL_PANEL_INVEST_DETAIL_OPERATION = CONTROL_PANEL + CONTROL_PANEL_INVEST_DETAIL_OPERATION;
export const URL_CONTROL_PANEL_PENALTY_DETAIL_OPERATION = CONTROL_PANEL + CONTROL_PANEL_PENALTY_DETAIL_OPERATION;
export const URL_CONTROL_PANEL_INVEST_PRODUCT = CONTROL_PANEL + CONTROL_PANEL_INVEST_PRODUCT;
export const URL_CONTROL_PANEL_OPERATION_DETAIL = CONTROL_PANEL + CONTROL_PANEL_OPERATION_DETAIL;
export const URL_CONTROL_PANEL_AGENT_STATISTICS = CONTROL_PANEL + CONTROL_PANEL_AGENT_STATISTICS;
export const URL_CONTROL_PANEL_ACTION_AGENT = CONTROL_PANEL + CONTROL_PANEL_ACTION_AGENT;
export const URL_CONTROL_PANEL_OPERATION_VALIDATION = CONTROL_PANEL + CONTROL_PANEL_OPERATION_VALIDATION;
export const URL_CONTROL_PANEL_GENERAL_INVESTMENT = CONTROL_PANEL + CONTROL_PANEL_GENERAL_INVESTMENT;

//Tariff sheet
const TARIFF = '/tariffs/';
export const TARIFF_DISCOUNT = 'discount';
export const TARIFF_INTEREST = 'interest';
export const TARIFF_CI_CO = 'ci-co';
export const TARIFF_LEASING = 'leasing';
export const TARIFF_IRREGULAR_QUOTAS = 'irregular-quotas';

export const URL_TARIFF_DISCOUNT = TARIFF + TARIFF_DISCOUNT;
export const URL_TARIFF_INTEREST = TARIFF + TARIFF_INTEREST;
export const URL_TARIFF_CI_CO = TARIFF + TARIFF_CI_CO;
export const URL_TARIFF_LEASING = TARIFF + TARIFF_LEASING;
export const URL_TARIFF_IRREGULAR_QUOTAS = TARIFF + TARIFF_IRREGULAR_QUOTAS;

//Payment for certifications
const PAYMENTCERT = '/paymentcert/';
export const PAYMENTCERT_REGISTER = 'register';
export const PAYMENTCERT_HISTORY = 'history';

export const URL_PAYMENTCERT_REGISTER = PAYMENTCERT + PAYMENTCERT_REGISTER;
export const URL_PAYMENTCERT_HISTORY = PAYMENTCERT + PAYMENTCERT_HISTORY;

//Users
const USERS = '/users/';
export const USERS_DETAIL_USER = 'detail-user';
export const USERS_NEW = 'new';
export const USERS_EDIT = 'edit';
export const USERS_WHITELIST = 'whitelist';
export const USERS_BRAND = 'brand';
export const USERS_ECOMMERCE = 'ecommerce';
export const USERS_ADMIN_REPORT = 'adminReport';
export const USERS_PASSWORD_POLICY = 'passwordPolicy';
export const USERS_DIGITAL_SIGNATURE = 'digitalSignature';
export const USERS_REGISTER_USER = 'register-user';
export const USERS_SEARCH = 'search';
export const USERS_CHANGE_PASSWORD = '/changePassword';
export const USERS_OWN_PASSWORD = 'own-password';
export const USERS_OTHER_PASSWORD = 'other-password';
export const USERS_SEARCH_OPERATIONS = 'search-operation';

export const URL_USERS_DETAIL_USER = USERS + USERS_DETAIL_USER;
export const URL_USERS_NEW = USERS + USERS_NEW;
export const URL_USERS_EDIT = USERS + USERS_EDIT;
export const URL_USERS_WHITELIST = USERS + USERS_WHITELIST;
export const URL_USERS_BRAND = USERS + USERS_BRAND;
export const URL_USERS_ECOMMERCE = USERS + USERS_ECOMMERCE;
export const URL_USERS_ADMIN_REPORT = USERS + USERS_ADMIN_REPORT;
export const URL_USERS_PASSWORD_POLICY = USERS + USERS_PASSWORD_POLICY;
export const URL_USERS_DIGITAL_SIGNATURE = USERS + USERS_DIGITAL_SIGNATURE;
export const URL_USERS_REGISTER_USER = USERS + USERS_REGISTER_USER;
export const URL_USERS_SEARCH = USERS + USERS_SEARCH;
export const URL_USERS_OWN_PASSWORD = USERS + USERS_OWN_PASSWORD;
export const URL_USERS_OTHER_PASSWORD = USERS + USERS_OTHER_PASSWORD;
export const URL_USERS_SEARCH_OPERATIONS = USERS + USERS_SEARCH_OPERATIONS;

//UserProfiles
const USER_PROFILES = '/user-profiles/';
export const USER_PROFILES_CREATE_PROFILE = 'create-profile';
export const USER_PROFILES_EDIT_PROFILE = 'edit-profile';
export const USER_PROFILES_DELETE_PROFILE = 'delete-profile';
export const USER_PROFILES_MANAGE_ATTRIBUTIONS = 'manage-attribution';

export const URL_USER_PROFILES_CREATE_PROFILE = USER_PROFILES + USER_PROFILES_CREATE_PROFILE;
export const URL_USER_PROFILES_EDIT_PROFILE = USER_PROFILES + USER_PROFILES_EDIT_PROFILE;
export const URL_USER_PROFILES_DELETE_PROFILE = USER_PROFILES + USER_PROFILES_DELETE_PROFILE;
export const URL_USER_PROFILES_MANAGE_ATTRIBUTIONS = USER_PROFILES + USER_PROFILES_MANAGE_ATTRIBUTIONS;

//Training
const TRAINING = '/training/';
export const TRAINING_DOCUMENTATION = 'documentation';
export const TRAINING_PILLS = 'pills';
export const TRAINING_TIPS = 'tips';
export const URL_TRAINING_DOCUMENTATION = TRAINING + TRAINING_DOCUMENTATION;
export const URL_TRAINING_PILLS = TRAINING + TRAINING_PILLS;
export const URL_TRAINING_TIPS = TRAINING + TRAINING_TIPS;

//Help
export const HELP = '/help';

//Home
export const HOME = '/home';

//Requests
const REQUESTS = '/requests/';
export const REQUESTS_PANEL = 'panel';
export const REQUESTS_CALCULATOR = 'calculator';
export const REQUESTS_CALCULATOR_AUTOS = 'calculator-autos';
export const REQUESTS_REQUEST = 'request';
export const REQUESTS_REQUEST_AUTOS = 'request-auto';
export const REQUESTS_REQUEST_MG_NO_SHOPPING = 'request-mg-no-shopping';
export const REQUESTS_REQUEST_MG = 'request-mg';
export const REQUESTS_REQUEST_BP = 'request-bp';
export const REQUESTS_REQUEST_CG = 'request-cg';
export const REQUESTS_UPDATE_DOCUMENTATION = 'update-documentation';
export const REQUESTS_SHOW_EDIT = 'request-show-edit';
export const REQUESTS_PENDING_INE = 'pending-ine';
export const REQUESTS_PENDING_VIDEOSELFING = 'pending-videoselfing';
export const REQUESTS_LOGALTY_CONSENTS = 'logalty-consents';
export const REQUESTS_LOGALTY_SIGNATURE = 'logalty-signature';
export const REQUESTS_PARTICIPANTS_LIST = 'participants-list';
export const REQUEST_LOGALTY_CALL_BACK_IMAGE = 'logalty-call-back-image'; //TODO: Is it needed?
export const REQUEST_LOGALTY_CALL_BACK = 'logalty-call-back';
export const REQUEST_LOGALTY_CALL_BACK_MERCHANT = 'logalty-call-back-merchant';
export const REQUESTS_LANDING_VIDEOSELFING = 'landing-videoselfing';
export const REQUESTS_FINISH_VIDEOSELFING = 'landing-finish-videoselfing';
export const LANDING_VIDEOSELFING = '/landing-videoselfing/';

export const URL_REQUESTS_PANEL = REQUESTS + REQUESTS_PANEL;
export const URL_REQUESTS_CALCULATOR = REQUESTS + REQUESTS_CALCULATOR;
export const URL_REQUESTS_CALCULATOR_AUTOS = REQUESTS + REQUESTS_CALCULATOR_AUTOS;
export const URL_REQUESTS_REQUEST = REQUESTS + REQUESTS_REQUEST;
export const URL_REQUESTS_REQUEST_AUTOS = REQUESTS + REQUESTS_REQUEST_AUTOS;
export const URL_REQUESTS_REQUEST_MG_NO_SHOPPING = REQUESTS + REQUESTS_REQUEST_MG_NO_SHOPPING;
export const URL_REQUESTS_REQUEST_MG = REQUESTS + REQUESTS_REQUEST_MG;
export const URL_REQUESTS_REQUEST_BP = REQUESTS + REQUESTS_REQUEST_BP;
export const URL_REQUESTS_REQUEST_CG = REQUESTS + REQUESTS_REQUEST_CG;
export const URL_REQUESTS_UPDATE_DOCUMENTATION = REQUESTS + REQUESTS_UPDATE_DOCUMENTATION;
export const URL_REQUESTS_SHOW_EDIT = REQUESTS + REQUESTS_SHOW_EDIT;
export const URL_REQUESTS_PENDING_INE = REQUESTS + REQUESTS_PENDING_INE;
export const URL_REQUESTS_PENDING_VIDEOSELFING = REQUESTS + REQUESTS_PENDING_VIDEOSELFING;
export const URL_REQUESTS_LOGALTY_CONSENTS = REQUESTS + REQUESTS_LOGALTY_CONSENTS;
export const URL_REQUESTS_LOGALTY_SIGNATURE = REQUESTS + REQUESTS_LOGALTY_SIGNATURE;
export const URL_REQUESTS_PARTICIPANTS_LIST = REQUESTS + REQUESTS_PARTICIPANTS_LIST;
export const URL_REQUESTS_LANDING_VIDEOSELFING = REQUESTS + REQUESTS_LANDING_VIDEOSELFING;
//Login
export const LOGIN = '/login';
//Activity
const ACTIVITY = '/activity/';
export const ACTIVITY_PANEL = 'panel';
export const ACTIVITY_PAYMENTS = 'payments';
export const ACTIVITY_MACRO = 'macro';
export const ACTIVITY_MACRO_CURRENT_MONTH = 'macro-monthly';
export const URL_ACTIVITY_PANEL = ACTIVITY + ACTIVITY_PANEL;
export const URL_ACTIVITY_PAYMENTS = ACTIVITY + ACTIVITY_PAYMENTS;
export const URL_ACTIVITY_MACRO = ACTIVITY + ACTIVITY_MACRO;
export const URL_ACTIVITY_MACRO_CURRENT_MONTH = ACTIVITY + ACTIVITY_MACRO_CURRENT_MONTH;

//third party
export const THIRD_PARTY_SAML_SEARCH = '/third-party-saml-search';
export const THIRD_PARTY_SAML_SIGNATURE = '/third-party-saml-signature';
